module.exports = __webpack_public_path__ + "static/media/icon-delete-black.dae4bc17.svg";